import * as React from 'react';
import { Edit, SimpleForm, TextInput, BooleanInput, NumberInput, required, maxLength, minValue, Toolbar, SaveButton, useNotify, useRedirect } from 'react-admin';
import { Button } from '@mui/material';
import useAdmin from '../hooks/useAdmin';

const CustomToolbar = () => {
    const redirect = useRedirect();

    const handleBack = () => {
        redirect('/categories');
    };

    return (
        <Toolbar>
            <SaveButton />
            <Button color="primary" onClick={handleBack} style={{ marginLeft: '10px' }}>Back</Button>
        </Toolbar>
    );
};

export const CategoryEdit = (props: any) => {
    const notify = useNotify();
    const redirect = useRedirect();

    const onSuccess = () => {
        notify('resources.categories.notification.updated', {
            type: 'info',
            undoable: true,
            messageArgs: { smart_count: 1, name: 'Category' }
        });
        redirect('/categories');
    };
    useAdmin();
    return (
        <Edit {...props} mutationOptions={{onSuccess: onSuccess}}>
            <SimpleForm toolbar={<CustomToolbar />}>
                <TextInput source="category_name" label="Name" validate={[required(), maxLength(10)]}/>
                <TextInput source="category_description" label="Description" validate={maxLength(50)}/>
                <NumberInput source="moq" label="MOQ (MT)" min={1} step={1} validate={[required(), minValue(1)]} />
                <BooleanInput source="is_virgin" label="Virgin" />
                <BooleanInput source="is_reprocessed" label="Reprocessed" />
            </SimpleForm>
        </Edit>
    );
};

export default CategoryEdit;
